var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReturn)?_c('main',{staticClass:"top_btn",style:({bottom: _vm.positionBtm + 'px'}),on:{"click":_vm.returnTop}},[_c('i',{staticClass:"iconfont icon-top"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }